module.exports = __webpack_public_path__ + "static/media/loading.abb58157.gif";